/**
 * The text tag group wrapper excluded attributes.
 * @type {String[]}
 */
export const GROUP_EXCLUDED_ATTRIBUTES = ['tag', 'viewBox', 'fontSize', 'fontFamily', 'fontWeight', 'fontStyle'];
